<div class="container">
    <div
        class="p-3"
        *ngIf="params.pendingData; else show"
    >
        <cmps-wait-status> </cmps-wait-status>
    </div>
    <ng-template #show>
        <div
            class="insight-backdrop-overlay"
            (click)="popUpService.hide()"
            *ngIf="popUpVisible"
        ></div>
        <div class="row">
            <div
                *ngIf="params.invalidUser"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    The selected user is outside the hierarchy.
                </h6>
            </div>
            <div
                *ngIf="params.invalidStartDate"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    Please check the entered start date.
                </h6>
            </div>
            <div
                *ngIf="params.invalidEndDate"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    Please check the entered end date.
                </h6>
            </div>
            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label class="mr-3 mb-0"> Report Population </label>
                    <ng-select
                        [options]="reportPopulations"
                        [(ngModel)]="params.populationType"
                        (ngModelChange)="onSelectPopulationType()"
                        placeholder="Select Population"
                    ></ng-select>
                </div>
            </div>

            <div
                class="mt-3 col-6"
                [ngSwitch]="params.populationType"
            >
                <div class="flex-form">
                    <ng-container
                        *ngSwitchCase="TdReportPopulationType.SuperGroup"
                    >
                        <label class="mr-3 mb-0"> Select One </label>
                        <ng-select
                            [options]="superGroups"
                            [(ngModel)]="params.defaultPopulationID"
                            (selected)="selectSuperGroup($event)"
                            placeholder="Select SuperGroup"
                        ></ng-select>
                    </ng-container>
                    <ng-container
                        *ngSwitchCase="TdReportPopulationType.Individual"
                    >
                        <label class="mr-3 mb-0">Individual:&nbsp;</label>
                        <span class="f-s-75-2 form-value">{{
                            params.populationID?.userName
                        }}</span>
                        <button
                            (click)="onSelectUser($event)"
                            class="green btn-mini"
                        >
                            <cmps-icon svgIcon="pencil"></cmps-icon>
                        </button>
                    </ng-container>
                </div>
            </div>

            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label
                        class="mr-3 mb-0"
                        for="reportStartDate"
                    >
                        Start Date
                    </label>

                    <div class="input-group">
                        <input
                            id="reportStartDate"
                            class="form-control"
                            [(ngModel)]="params.startDate"
                            (ngModelChange)="onSelectDate()"
                            [placeholder]="i18n._646_YYYY_MM_DD | translate"
                            aria-labelledby="reportStartDate"
                            ngbDatepicker
                            [maxDate]="maxDate"
                            #dpStart="ngbDatepicker"
                        />
                        <div class="input-group-append">
                            <button
                                type="button"
                                class="btn btn-secondary cmps-cdk-py-0dot5"
                                aria-label="Toggle date picker"
                                [attr.aria-expanded]="dpStart.isOpen()"
                                (click)="dpStart.toggle()"
                            >
                                <cmps-icon
                                    class="green"
                                    svgIcon="calendar"
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label
                        class="mr-3 mb-0"
                        for="reportEndDate"
                    >
                        End Date
                    </label>

                    <div class="input-group">
                        <input
                            id="reportEndDate"
                            class="form-control"
                            [(ngModel)]="params.endDate"
                            (ngModelChange)="onSelectDate()"
                            [placeholder]="i18n._646_YYYY_MM_DD | translate"
                            aria-labelledby="reportEndDate"
                            ngbDatepicker
                            [maxDate]="maxDate"
                            #dpEnd="ngbDatepicker"
                        />
                        <div class="input-group-append">
                            <button
                                type="button"
                                class="btn btn-secondary cmps-cdk-py-0dot5"
                                aria-label="Toggle date picker"
                                [attr.aria-expanded]="dpEnd.isOpen()"
                                (click)="dpEnd.toggle()"
                            >
                                <cmps-icon
                                    class="green"
                                    svgIcon="calendar"
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 col-12">
                <button
                    class="btn btn-primary pull-right"
                    [disabled]="generateReportDisabled"
                    type="button"
                    (click)="onGenerateReport()"
                >
                    <cmps-icon svgIcon="file-document"></cmps-icon>
                    Generate Report
                </button>
            </div>
        </div>
    </ng-template>
</div>
